import { createFileRoute } from '@tanstack/react-router';
import { PublicHomePage } from '../../features/community';

export const Route = createFileRoute('/_public/')({ component: PublicHomePage });
